import { LoadingOutlined } from '@ant-design/icons';
import styles from './SubmitButton.module.scss';

export default function SubmitButton({
  children,
  isLoading,
  disabled,
  className = '',
  type = 'submit',
  onClick,
}) {
  return (
    <button
      type={type}
      className={`btn-primary w-button ${styles.submitButton} ${isLoading ? styles.loading : ''} ${className}`}
      disabled={isLoading || disabled}
      onClick={onClick}
    >
      {isLoading ? (
        <div>
          <LoadingOutlined className={styles.spinner} />
        </div>
      ) : (
        <div>{children}</div>
      )}
    </button>
  );
}
